export enum AddToFavoriteTypeEnum {
  CATALOG = 'CATALOG',
  SINGLE_PAGE = 'SINGLE_PAGE',
  SHOP = 'SHOP',
  PRODUCT= 'PRODUCT',
  BASKET = 'BASKET'
}
